import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-calendar@9.15.5@rc-calendar/es/index.js
// module id = 600
// module chunks = 0